import { render, staticRenderFns } from "./FeedingPlanView.vue?vue&type=template&id=024a0afd&scoped=true"
import script from "./FeedingPlanView.vue?vue&type=script&lang=js"
export * from "./FeedingPlanView.vue?vue&type=script&lang=js"
import style0 from "./FeedingPlanView.vue?vue&type=style&index=0&id=024a0afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a0afd",
  null
  
)

export default component.exports